import { translate } from "../i18n/index.js";
/**
 * **المنصّات بأسمائها — خريطةٌ واحدة.**
 *
 * فالمنصّةُ تُحفَظ مفتاحاً (`instagram`) كما جاءت من v2 ومن السيرفر، **وكانت
 * تُعرَض كذلك**: «instagram» بالإنجليزي الصغير في طابور النشر وفي لوحة العنصر
 * وجدول العميل. والمفتاحُ يبقى مفتاحاً في القاعدة، **والإنسانُ يقرأ الاسم**.
 *
 * والقائمةُ هي ما يُختار منه في «عنصر جديد»؛ ومفتاحٌ يأتي من خارجها **يُعرَض كما
 * هو** — لا يُخفى، فيُقرأ مرّةً فيُسمّى هنا.
 */
const PLATFORM_NAME = {
    instagram: "platforms.instagram",
    facebook: "platforms.facebook",
    tiktok: "platforms.tiktok",
    linkedin: "platforms.linkedin",
    x: "platforms.x",
    youtube: "platforms.youtube",
    snapchat: "platforms.snapchat",
    threads: "platforms.threads",
};
export const PLATFORM_KEYS = Object.keys(PLATFORM_NAME);
export function platformLabel(key, locale) {
    const name = PLATFORM_NAME[key.toLowerCase()];
    return name === undefined ? key : translate(locale, name);
}
//# sourceMappingURL=platforms.js.map